import React, { useState, useEffect, useCallback } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'; // <--- 1. Import do i18n
import "./weldingCapabilities.css"

// --- IMPORTS DOS LOGOS ---
import logoPT from "../../imagens/logos/logoWelding.png"
// ⚠️ VERIFIQUE SE O NOME DO ARQUIVO ABAIXO EXISTE NA SUA PASTA
import logoEN from "../../imagens/logos/logoWeldingEn.png" 

function WeldingsCapabilities({ listWelding }) {
  
  // <--- 2. Hook de tradução
  const { t, i18n } = useTranslation();

  // <--- 3. Lógica do logo dinâmico
  const logoByLanguage = i18n.language === 'en' ? logoEN : logoPT;

  const [slideNumber, setSlideNumber] = useState(0)
  const [openModal, setOpenModal] = useState(false)

  const handleOpenModal = (index) => {
    setSlideNumber(index)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const prevSlide = useCallback(() => {
    slideNumber === 0 ?
      setSlideNumber(listWelding.length - 1) :
      setSlideNumber(slideNumber - 1)
  }, [slideNumber, listWelding.length])


  const nextSlide = useCallback(() => {
    slideNumber + 1 === listWelding.length
      ? setSlideNumber(0) :
      setSlideNumber(slideNumber + 1)
  }, [slideNumber, listWelding.length])

  useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.key) {
        case 'Escape':
          handleCloseModal()
          break
        case 'ArrowLeft':
          prevSlide()
          break;
        case 'ArrowRight':
          nextSlide()
          break;
        default:
          break;
      }
    };

    if (openModal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [openModal, nextSlide, prevSlide]);

  return (
    <div>
      {
        openModal &&
        <div className='weldSliderWrap'>
          <FontAwesomeIcon icon={faCircleChevronLeft} className='weldBtnPrev' onClick={() => prevSlide()} />
          <FontAwesomeIcon icon={faCircleChevronRight} className='weldBtnNext' onClick={() => nextSlide()} />
          <FontAwesomeIcon icon={faCircleXmark} className='weldBtnClose' onClick={() => handleCloseModal()} />
          <img className='weldFullScreenImage' src={listWelding[slideNumber].img} alt="FullScreenImage" />
        </div>
      }
      
      {/* LOGO */}
      <div className='img-custom-size img-fluid ms-2'>
        {/* <--- 4. Uso da variável do logo */}
        <img src={logoByLanguage} alt='logoWelding' />
      </div>

      <div className='weldGalleryWrap mx-2'>
        {
          listWelding && listWelding.map((image, index) => {
            return (
              <div className='weldSingle'
                key={index}
                onClick={() => handleOpenModal(index)}
              >
                <img src={image.img} alt="welding"></img>

              </div>
            )

          })
        }
      </div>
      
      {/* BOTÃO VOLTAR */}
      <div className="text-center text-nowrap my-4">
        <Link to="/Capabilities/Production">
          {/* <--- 5. Tradução do botão */}
          <button className="buttonCapabilities">
            {t('productionCapabilities.backButton')}
          </button>
        </Link>
      </div>

    </div>
  )

}

export default WeldingsCapabilities